import React, { Component } from 'react';
import { Button, Alert } from 'react-bootstrap';
import Recorder from '../components/Recorder';
import api from '../helpers/ApiClient';
import shortid from 'shortid';
import Loader from '../components/Loader';
import VMNav from '../components/VMNav';
import linkIcon from '../images/link-icon.svg'
import audioIllustration from '../images/audio-illustration.svg'
import videoIllustration from '../images/video-illustration.svg'
import youtubeIllustration from '../images/youtube-illustration.svg'
import imageIllustration from '../images/image-illustration.svg'

class VirtualMessage extends Component {

  constructor(props) {
    super(props);

    this.state = {
      chooseType: true,
      uploadingFile: false,
      skip: true,
      touchStartLocation: null
    };
  }

  componentWillMount(){

    window.addEventListener('message', e => {
      if((e.origin !== 'https://giftr.my' || e.origin != 'https://giftr.sg') || !e.data){
        return
      }
      if(e.data.close_popup){
        this.handleOnClickBack()
      }
    })
  }

  handleUploadMessage = async (media) => {

    this.setState({
      error: '',
      chooseType: true,
      uploadingFile: true
    })

    let fileUrl, fileLink

    if(media.type){
      let ext = media.type.includes('audio') ? 'm4a' : 'mp4'
      let type = media.type.includes('audio') ? 'audio/mp4' : 'video/mp4'

      if(media.type.includes('image')){
        type = media.type
        ext = type.split('/')[1]
      }

      let file = new File([media], `${shortid.generate()}.${ext}`, {
        type
      })
      const body = {
        ext,
        type
      }

      // get presigned url
      const data = await fetch('https://bh5uwl05lc.execute-api.ap-southeast-1.amazonaws.com/dev/vm', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
      })
        .then(response => response.json())
        .catch(error => {
          this.setState({
            error,
            uploadingFile: false,
          })
        })

      const { shortUrl, presignedUrl, bucket, key } = data;
      fileLink = `https://s3.ap-southeast-1.amazonaws.com/${bucket}/${key}`;

      // upload
      const uploaded = await fetch(presignedUrl, {
        method: "PUT",
        body: file,
      }).catch(error => {
        this.setState({
          error,
          uploadingFile: false,
        })
      })

      if(uploaded.status !== 200){
        console.log(uploaded);
        return
      }

      console.log('uploaded');

      // transcode
      if(media.type.includes('audio') || media.type.includes('video')){
        fetch('https://p4ao32k20d.execute-api.ap-southeast-1.amazonaws.com/v1/transcode', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            bucket,
            key,
            ext,
            type: media.type.includes('audio') ? 'audio/mp4' : 'video/mp4',
          })
        })
      }

      if(data.code === 'NetworkingError'){
        this.setState({ err: data.message })
      }

      fileUrl = shortUrl
    } else {
      fileUrl = media
      fileLink = media
    }

    window.parent.postMessage({ fileUrl, fileLink }, "https://giftr.my");
    window.parent.postMessage({ fileUrl, fileLink }, "https://giftr.sg");

    this.setState({
      uploadingFile: false
    })
  }

  handleOnClickAddImage = () => {
    this.setState({
      chooseType: false,
      type: 'image',
    })
  }

  handleOnClickAddVideo = () => {
    this.setState({
      chooseType: false,
      type: 'video',
    })
  }

  handleOnClickAddAudio = () => {
    this.setState({
      chooseType: false,
      type: 'audio',
    })
  }

  handleOnClickAddYouTubeLink = () => {
    this.setState({
      chooseType: false,
      type: 'youtube',
    })
  }

  handleOnClickBack = () => {
    this.setState({
      skip: true,
      error: '',
      chooseType: true,
    })
  }

  addError = err => {
    this.setState({
      error: err
    })
  }

  handleShowSkip = skip => {
    if(this.state.skip !== skip){
      this.setState({ skip })
    }
  }

  handleOnClickSkip = () => {
    this.setState({
      error: '',
      chooseType: true,
    })

    window.parent.postMessage({ skipAndSubmit: true }, "https://giftr.my");
    window.parent.postMessage({ skipAndSubmit: true }, "https://giftr.sg");
  }

  handleOnTouchStart = (e) => {
    const firstTouch = e.touches[0];
    const location = {
      xDown: firstTouch.clientX,
      yDown: firstTouch.clientY
    }

    this.setState({
      touchStartLocation: location
    })
  }

  handleOnTouchMove = (e) => {
    if ( ! (this.state.touchStartLocation.xDown) || ! (this.state.touchStartLocation.yDown) ) { //no mouse down detected, then exit
      return;
    }

    var xUp = e.touches[0].clientX;
    var yUp = e.touches[0].clientY;

    var xDiff = this.state.touchStartLocation.xDown - xUp;
    var yDiff = this.state.touchStartLocation.yDown - yUp;

    if ( xDiff  > yDiff  ) {/*most significant*/
      if ( xDiff < 0 ) {  //left swipe
        window.parent.postMessage({ prevTab: true }, "https://giftr.my");
        window.parent.postMessage({ prevTab: true }, "https://giftr.sg");
      }
    }

    /* reset values */
    const location = {
      xDown: null,
      yDown: null
    }
    this.setState({
      touchStartLocation: location
    })
  }

  render() {
    const { chooseType, error, uploadingFile, type, skip } = this.state;

    return (
      <div style={{height: '97vh'}} className="flex-column vm-container">
        {
          uploadingFile &&
            <Loader style={{margin: 'auto'}} />
        }
        {
          error &&
            <Alert bsStyle="danger">
              <div>{error}</div>
            </Alert>
        }
        {
          !uploadingFile && chooseType &&
            <div className="vm-mobile-layout" style={{display: 'flex', flexGrow: '1', flexDirection: 'column'}}>
              <VMNav showBack={!uploadingFile && !chooseType} showSkip={skip} back={this.handleOnClickBack} skip={this.handleOnClickSkip}/>
              <div className="vm-option-container" onTouchStart={this.handleOnTouchStart} onTouchMove={this.handleOnTouchMove}>
                <div className="vm-option">
                  <img className="svg-illustration" src={imageIllustration} alt="upload image"/>
                  <p className="vm-desc">Share your thoughts with memorable shot or GIF</p>
                  <Button className="btn-virtual-message btn-virtual-message-type" onClick={this.handleOnClickAddImage} onTouchStart={this.handleOnClickAddImage}>
                    <img className="vm-icons" src="video-icon.svg"/>
                    <span style={{minWidth: '160px', display: 'inline-block'}}>
                      Add photo/GIF
                    </span>
                  </Button>
                  <p className="vm-note">Maximum image size: 2MB</p>
                </div>
                <div className="vm-option">
                  <img className="svg-illustration" src={videoIllustration} alt="upload video"/>
                  <p className="vm-desc">Wish your loved ones through a video</p>
                  <Button className="btn-virtual-message btn-virtual-message-type" onClick={this.handleOnClickAddVideo} onTouchStart={this.handleOnClickAddVideo}>
                    <img className="vm-icons" src="video-icon.svg"/>
                    <span style={{minWidth: '160px', display: 'inline-block'}}>
                      Add video
                    </span>
                  </Button>
                  <p className="vm-note">Maximum video size: 2 minutes or 20MB</p>
                </div>
                <div className="vm-option">
                  <img className="svg-illustration" src={audioIllustration} alt="upload audio"/>
                  <p className="vm-desc">Send a heartfelt audio message</p>
                  <Button className="btn-virtual-message btn-virtual-message-type" onClick={this.handleOnClickAddAudio}>
                    <img className="vm-icons" src="mic-icon.svg"/>
                    <span style={{minWidth: '160px', display: 'inline-block'}}>
                      Add audio
                    </span>
                  </Button>
                  <p className="vm-note">Maximum audio size: 2 minutes or 20MB</p>
                </div>
                <div className="vm-option">
                  <img className="svg-illustration" src={youtubeIllustration} alt="youtube"/>
                  <p className="vm-desc">Share your favourite YouTube video</p>
                  <Button className="btn-virtual-message btn-virtual-message-type" onClick={this.handleOnClickAddYouTubeLink}>
                    <img className="vm-icons" src={linkIcon} alt="link icon"/>
                    <span style={{minWidth: '160px', display: 'inline-block'}}>
                      Add YouTube link
                    </span>
                  </Button>
                  <p className="vm-note">Maximum video size: None</p>
                </div>
              </div>
            </div>
        }
        {
          !uploadingFile && !chooseType &&
            <Recorder
              showSkip={this.handleShowSkip}
              skipVisible={skip}
              returnMedia={this.handleUploadMessage}
              addError={this.addError}
              back={this.handleOnClickBack}
              skip={this.handleOnClickSkip}
              prompt={
                (type === 'video' && 'Maximum video size: 2 minutes or 20MB') ||
                (type === 'audio' && 'Maximum audio size: 2 minutes or 20MB') ||
                (type === 'youtube' && 'Maximum video size: None') ||
                (type === 'image' && 'Maximum image size: 2MB')
              }
              type={type}
              mediaType={{
                audio: true,
                video: type === 'video' || type === 'image' ? {
                  facingMode: 'user',
                    height: { max: '720' }
              } : false
              }} />
        }
      </div>
    )
  }
}

export default VirtualMessage;
